import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  id: number;
  tone: 'info' | 'success' | 'error';
  message: string;
}

let nextId = 1;

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);

  function push(message: string, tone: Toast['tone'] = 'info'): void {
    const id = nextId++;
    toasts.value.push({ id, tone, message });
    setTimeout(() => dismiss(id), tone === 'error' ? 8000 : 4000);
  }

  function dismiss(id: number): void {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return {
    toasts,
    dismiss,
    info: (message: string) => push(message, 'info'),
    success: (message: string) => push(message, 'success'),
    error: (message: string) => push(message, 'error'),
  };
});
